import ScrabbleHelper from './ScrabbleHelper';

function App() {
  return (
    <div>
      <ScrabbleHelper />
    </div>
  );
}

export default App;